import { FC } from 'react'
import { Question } from './FAQ'
import { useCollabsibleItem } from 'services/Collapsible'
import { Button } from 'atoms'
import Styles from './LgQuestion.module.sass'

interface LgQuestionProps {
  id: string,
  groupId: string,
  item: Question,
}

const LgQuestion: FC<LgQuestionProps> = ({
  id,
  groupId,
  item: {
    question,
  }
}) => {
  const { collapsed, toggle } = useCollabsibleItem(groupId, id)

  return (
    <Button
      block
      onClick={toggle}
      theme={collapsed ? 'link' : 'default'}
      className={`text-end ${Styles.button}`}
    >
      {question}
    </Button>
  )
}

export default LgQuestion
